export enum CateringType {
  Undefined = 0,
  NoMeal = 10,
  DefaultMeal = 20,
  Vegetarian = 30,
}
